import React from 'react'
import PropTypes from 'prop-types'

function SectionHeader({title}) {
  return <div className='section-header'>
    <span><b>{title}</b></span>
    <span><i className='fa fa-solid fa-angle-down'></i></span>
  </div>
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default SectionHeader
